export default __webpack_public_path__ + "static/media/skippedmeal@3x.6c51a833.jpg";